export const getDefaultODataEventSearchString = (productName: string) => {
  return `$filter=ProductName eq '${productName}'`;
};
